module.exports = __webpack_public_path__ + "static/colgadas-001-0dc3046ffacc51504df74d7d20f5fc93.jpg";